import { ReactNativeFile } from './ReactNativeFile';

export const isExtractableFile = (value: any) => {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};
